// Route mappings for renewal flows based on product codes.
// Only motor (0101) and home (0710) renewals are active.
export const POLICY_TYPE_ROUTES = {
  "0101": "/renew/renew-motor-policy",
  "0710": "/renew/renew-home-policy",
};

// Policy type labels for display
export const POLICY_TYPE_LABELS = {
  "0101": { en: "Motor Insurance", ar: "تأمين السيارات" },
  "0204": { en: "Travel Insurance", ar: "تأمين السفر" },
  "0710": { en: "Home Insurance", ar: "تأمين المنزل" },
  "0222": { en: "Domestic Helper Insurance", ar: "تأمين العمالة المنزلية" },
  "0640": { en: "Personal Cyber Insurance", ar: "التأمين السيبراني الشخصي" },
  "0202": { en: "Personal Accident Insurance", ar: "تأمين الحوادث الشخصية" },
};

// Generic renewal page constants
export const GENERIC_RENEWAL_PAGE_SELECT_POLICY = "GENERIC_RENEWAL_PAGE_SELECT_POLICY";
